(function () {
  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  function updateThumb(track, thumb, bar) {
    var scrollable = track.scrollWidth - track.clientWidth;
    var barW = bar.clientWidth;
    var minPx = 18;

    if (scrollable <= 0 || barW <= 0) {
      thumb.style.width = '100%';
      thumb.style.left = '0';
      return;
    }

    var ratio = track.clientWidth / track.scrollWidth;
    var thumbW = ratio * barW;
    if (thumbW < minPx) thumbW = minPx;
    if (thumbW > barW) thumbW = barW;

    var maxLeft = barW - thumbW;
    var progress = track.scrollLeft / scrollable;
    if (progress < 0) progress = 0;
    if (progress > 1) progress = 1;

    thumb.style.width = thumbW + 'px';
    thumb.style.left = progress * maxLeft + 'px';
  }

  function initSection(section) {
    var track = section.querySelector('[data-rbc-track]');
    var thumb = section.querySelector('[data-rbc-thumb]');
    var bar = thumb && thumb.parentElement;
    if (!track || !thumb || !bar) return;

    var raf = 0;
    function scheduleUpdate() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        updateThumb(track, thumb, bar);
      });
    }

    track.addEventListener('scroll', scheduleUpdate, { passive: true });

    var debouncedResize = debounce(scheduleUpdate, 150);
    window.addEventListener('resize', debouncedResize);

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(scheduleUpdate);
      ro.observe(track);
      ro.observe(bar);
    }

    scheduleUpdate();
  }

  function initAll() {
    document.querySelectorAll('[data-rbc-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();